import React from "react";
import { Redirect } from "react-router-dom";

import { ErrorPage } from "@/ErrorPage";
import { FEATURES } from "@/features/registry";
import { FeatureSplashLoadingPlaceholder } from "@/splash/FeatureSplashLoadingPlaceholder";
import { useFeatureAccess } from "@/hooks/useFeatureAccess";
import type { Feature } from "@/types/feature";

export interface FeatureChildRouteGuardProps {
  feature: Feature;
  children: React.ReactNode;
}

export function FeatureChildRouteGuard({
  feature,
  children,
}: FeatureChildRouteGuardProps) {
  const access = useFeatureAccess(feature);

  switch (access.state) {
    case "loading":
      return <FeatureSplashLoadingPlaceholder />;
    case "coming-soon":
      return <ErrorPage />;
    case "no-permissions":
    case "needs-ai-consent":
    case "get-started":
      return <Redirect to={FEATURES[feature].rootPath} />;
    case "feature":
      return <>{children}</>;
  }
}
